<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Title -->
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Sistema</span>
        <h3 class="page-title">Configurações</h3>
      </d-col>
    </d-row>

    <d-card>
      <d-tabs card ref="tabs">
        <d-tab title="Dados da empresa" active class="p-3">
          <company-form/>
        </d-tab>
        <d-tab title="Textos dos impressos" class="p-3">
          <messages-form/>
        </d-tab>
        <d-tab title="Variáveis do sistema" class="p-3">
          <settings-form/>
        </d-tab>
        <d-tab title="Orçamento" class="p-3">
          <quotation-settings-form/>
        </d-tab>
        <d-tab title="Controle de acesso" class="p-3" v-if="isAdmin">
          <access-control-form/>
        </d-tab>
      </d-tabs>
    </d-card>
    <edit-editor-text-modal
      :alert="'Ao salvar não alterará os contratos já criados'"
    />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import CompanyForm from '_modules/settings/components/CompanyForm.vue';
import MessagesForm from '_modules/settings/components/MessagesForm.vue';
import SettingsForm from '_modules/settings/components/SettingsForm.vue';
import AccessControlForm from '_modules/settings/components/AccessControlForm.vue';
import QuotationSettingsForm from '_modules/settings/components/QuotationSettingsForm.vue';
import EditEditorTextModal from '_shared/EditEditorTextModal.vue';
import {
  _LOAD_MODEL_COMPANY_,
  _LOAD_MODEL_MESSAGE_,
  _LOAD_MODEL_SETTING_,
  COMPANY, MESSAGES,
  SETTINGS,
} from '../components/SettingsModel';

export default {
  name: 'setting-profile',
  components: {
    CompanyForm,
    MessagesForm,
    SettingsForm,
    AccessControlForm,
    EditEditorTextModal,
    QuotationSettingsForm,
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getSettings',
      'checkAdmin',
    ]),
    company() {
      const { company } = this.$store.state.settings;
      if (company) {
        Events.$emit(_LOAD_MODEL_COMPANY_, company);
        return company;
      }
      return COMPANY;
    },
    getSettingsSystem() {
      this.setToggle({ type: 'progress', bool: true });
      this.getSettings()
        .then(() => {
          this.loadSettings();
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    loadSettings() {
      this.company();
      this.messages();
      this.settings();
    },
    messages() {
      const { messages } = this.$store.state.settings;
      if (messages) {
        Events.$emit(_LOAD_MODEL_MESSAGE_, messages);
        return messages;
      }
      return MESSAGES;
    },
    settings() {
      const { settings } = this.$store.state.settings;
      if (settings) {
        Events.$emit(_LOAD_MODEL_SETTING_, settings);
        return settings;
      }
      return SETTINGS;
    },
  },
  mounted() {
    this.checkAdmin()
      .then(() => {
        const tabs = this.$refs.tabs;
        if (tabs?.updateTabs && typeof tabs.updateTabs === 'function')
          tabs.updateTabs();
      });
    this.getSettingsSystem();
  },
};
</script>

<style lang="scss">
.tabs {
  .card-header { background: rgba(0, 0, 0, 0.03); }
}
</style>
